import React, { FC, memo } from 'react';
import api from 'src/config/api';
import { Box, BoxProps } from '@material-ui/core';

interface Props extends BoxProps {
  documentId?: string;
}

const RankImage: FC<Props> = ({ documentId, ...boxProps }) => {
  if (!documentId) {
    return null;
  }

  const { endpoint } = api.document.download(documentId);

  return (
    <Box borderRadius='50%' bgcolor='white' width={40} height={40} paddingX='7px' {...boxProps}>
      <img src={endpoint} alt='rank logo' style={{ objectFit: 'contain' }} width='100%' height='100%' />
    </Box>
  );
};

export default memo(RankImage);
